







































































// eslint-disable-next-line no-unused-vars
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Search',
  data() {
    return {
      showFilter: false as boolean,
      showSort: false as boolean,
      sortDir: 'down' as string,
      sort: 'date' as string,
      filterD: [] as Array<string>,
      config: {
        // @ts-ignore
        handler: this.outside,
        events: ['click', 'touchstart', 'touchmove'],
      },
      configF: {
        // @ts-ignore
        handler: this.outsideF,
        events: ['click', 'touchstart', 'touchmove'],
      },
      search: '' as string,
      prevSearch: '' as string,
      filteredData: this.items as Array<any>,
      extraPadding: 10 as number,
    };
  },
  props: {
    items: Array,
    sortFunc: Function,
    sortTypes: Array,
    sortDefault: String,
    dirDefault: String,
    filterFunc: Function,
    filterTypes: Array as PropType<string[]>,
  },
  watch: {
    search() {
      let list = this.filterFunc(this.items, this.filterD, this.search);
      list = this.sortFunc(list, this.sort, this.sortDir);
      this.filteredData = list;
      this.$emit('sortedData', this.filteredData);
    },
    filterD: {
      handler() {
        let list = this.filterFunc(this.items, this.filterD, this.search);
        list = this.sortFunc(list, this.sort, this.sortDir);
        this.filteredData = list;
        this.$emit('sortedData', this.filteredData);
        this.extraPad();
      },
      deep: true,
    },
  },
  mounted() {
    this.sort = this.sortDefault;
    this.sortDir = this.dirDefault;
    this.filteredData = this.sortFunc(this.filteredData, this.sort, this.sortDir);
    this.$emit('sortedData', this.filteredData);
  },
  computed: {
  },
  methods: {
    extraPad(): void {
      let padding = 10
      + (parseInt(this.em().toString(), 10)
      * parseInt(this.filterD.length.toString(), 10)) * 1.3;
      if (this.filterD.includes('Delegate')) {
        padding += 50.48; // 55.48px + 1em of .badge width
      }
      if (this.filterD.includes('Chair')) {
        padding += 33.09; // 38.09px + 1em of .badge width
      }
      if (this.filterD.includes('Ongoing')) {
        padding += 50.2; // 55.2px + 1em of .badge width
      }
      if (this.filterD.includes('Best Delegate')) {
        padding += 73.58; // 78.58px + 1em of .badge width
      }
      if (this.filterD.includes('Present')) {
        padding += 45.48; // 55.48px + 1em of .badge width
      }
      if (this.filterD.includes('Present & Voting')) {
        padding += 88.09; // 38.09px + 1em of .badge width
      }
      if (this.filterD.includes('Not Present')) {
        padding += 65.2; // 55.2px + 1em of .badge width
      }
      if (this.filterD.includes('Asia')) {
        padding += 24.58; // 78.58px + 1em of .badge width
      }
      if (this.filterD.includes('Americas')) {
        padding += 48.09; // 38.09px + 1em of .badge width
      }
      if (this.filterD.includes('Africa')) {
        padding += 36.2; // 55.2px + 1em of .badge width
      }
      if (this.filterD.includes('Europe')) {
        padding += 40.58; // 78.58px + 1em of .badge width
      }
      if (this.filterD.includes('Oceania')) {
        padding += 45.58; // 78.58px + 1em of .badge width
      }
      console.log(padding, this.filterD);
      this.extraPadding = padding;
    },
    em(): number {
      if (document.querySelector('.badge')) return parseFloat(getComputedStyle(document.querySelector('.badge') as Element).fontSize);
      return 10;
    },
    del(event): void {
      if (this.filterD.length > 0
      && (event.target.selectionStart === 0 && this.prevSearch.length !== 1)) {
        this.filterD.pop();
      }
      this.prevSearch = this.search;
    },
    outside(e): void {
      if (!e.target.classList.contains('exclude')
      && !e.target.parentElement.classList.contains('exclude')) {
        this.showSort = false;
      }
    },
    outsideF(e): void {
      if (!e.target.classList.contains('excludeF')
      && !e.target.parentElement.classList.contains('excludeF')) {
        this.showFilter = false;
      }
    },
    filterData(tag): void {
      if (this.filterD.includes(tag)) {
        this.filterD = this.filterD.filter((f) => f !== tag);
      } else {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of this.filterTypes) {
          if (item === tag) {
            this.filterD.push(item);
            break;
          }
          if (typeof item === 'object') {
            let noReplace = true;
            this.filterD.forEach((f) => {
              if ((item as string).includes(tag) && (item as string).includes(f)) {
                this.filterD.splice(this.filterD.indexOf(f), 1, tag);
                noReplace = false;
              }
            });
            if (noReplace && (item as string).includes(tag)) {
              this.filterD.push(tag);
            }
          }
        }
      }
    },
    sortData(i): void {
      if (this.sort === i && this.sortDir === 'down') {
        this.sortDir = 'up';
      } else if (this.sort === i && this.sortDir === 'up') {
        this.sortDir = 'down';
      } else {
        this.sort = i;
      }
      this.filteredData = this.sortFunc(this.filteredData, i, this.sortDir);
    },
  },
});
